import { IntlShape } from 'react-intl'

import { DropdownOption } from './types'

export default <T = string>(intl: IntlShape, options: DropdownOption<T>[]) =>
  options.map((option) => ({
    ...option,
    label: intl.formatMessage({ id: option.label }),
  }))
